import { z } from 'zod';
export const cornType = (serviceName, resourceType, resourceId) => z
    .custom((val) => new RegExp(`^corn:${serviceName ? serviceName : '\\w+[-w]*\\w'}+:${resourceType ? resourceType : '\\w+[-w]*\\w'}+:${resourceId ? resourceId : '.'}+$`, 'g').test(val))
    // `type: 'string'` lets `@asteasolutions/zod-to-openapi` render this
    // `z.custom` brand (it can't infer a type otherwise and throws
    // `UnknownZodTypeError`). `mock` is a valid example used by
    // `@eigtech/make-mock` to generate corns that pass this validator (mock
    // libraries can't synthesize a value for `z.custom`). Note: `.meta()` values
    // pass through into generated OpenAPI docs.
    .meta({
    type: 'string',
    mock: `corn:${serviceName ?? 'service'}:${resourceType ?? 'resource'}:${resourceId ?? 'mock'}`,
});
export const CornSchema = cornType();
